export default __webpack_public_path__ + "static/media/sekiro.f396e5e0.jpg";